import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

/**
 * A hook to update pathname if it contains uppercase
 */
export function useLowercasePathname() {
  const history = useHistory();
  const { pathname, search } = useLocation();

  useEffect(() => {
    const lowercasePathname = pathname.toLowerCase();
    const newUrl = lowercasePathname + search;
    if (lowercasePathname !== pathname) {
      history.push(newUrl);
    }
  }, []);
}
